import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'AJOUT_DOC',
  title: 'Comment ajouter un document complémentaire ?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'A partir de l’onglet « Documents », cliquez en haut à droite sur '
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_DOC/FR_AJOUT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Puis sur « Ajouter un document »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_DOC/FR_AJOUT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Sélectionnez ou recherchez le document de votre choix'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_DOC/FR_AJOUT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Ensuite cliquez sur « Valider »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_AJOUT_DOC/FR_AJOUT_DOC_4.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Votre document s’ajoute directement à votre dossier. Vous n’avez plus qu’à le déposer.'
  }]
};
